import { useEffect, useState } from 'react';
import { FolderPlus, Image, LoaderCircle, Music2, Video, X } from 'lucide-react';

const MEDIA_TYPES = [
  { id: 'image', label: '图片', Icon: Image },
  { id: 'video', label: '视频', Icon: Video },
  { id: 'audio', label: '音频', Icon: Music2 },
];

export default function CanvasMaterialSaveDialog({
  source,
  collections = [],
  initialCollectionId = '',
  title = '加入收藏夹',
  submitLabel = '收藏',
  busy = false,
  onClose,
  onSubmit,
}) {
  const [name, setName] = useState('');
  const [collectionId, setCollectionId] = useState('');
  const [mediaType, setMediaType] = useState('image');

  useEffect(() => {
    if (!source) return;
    setName(String(source.name || '').trim());
    setMediaType(['image', 'video', 'audio'].includes(source.kind) ? source.kind : 'image');
    const preferred = collections.some((item) => item.id === initialCollectionId)
      ? initialCollectionId
      : collections[0]?.id || '';
    setCollectionId(preferred);
  }, [collections, initialCollectionId, source]);

  if (!source) return null;

  return <div className="canvas-dialog-backdrop" role="presentation" onPointerDown={(event) => {
    if (event.target === event.currentTarget && !busy) onClose?.();
  }}>
    <form className="canvas-material-dialog" role="dialog" aria-modal="true" aria-label={title} onSubmit={(event) => {
      event.preventDefault();
      if (!collectionId || !name.trim() || busy) return;
      onSubmit?.({ ...source, kind: mediaType, mediaType, name: name.trim(), category: collectionId });
    }}>
      <header>
        <div><FolderPlus size={18} /><strong>{title}</strong></div>
        <button type="button" onClick={onClose} disabled={busy} aria-label="关闭"><X size={17} /></button>
      </header>
      <div className="canvas-material-dialog__types" role="tablist" aria-label="收藏素材类型">
        {MEDIA_TYPES.map(({ id, label, Icon }) => <button
          type="button"
          role="tab"
          aria-selected={mediaType === id}
          className={mediaType === id ? 'is-active' : ''}
          disabled={Boolean(source.kind && source.kind !== id)}
          key={id}
          onClick={() => setMediaType(id)}
        ><Icon size={15} />{label}</button>)}
      </div>
      <div className="canvas-material-dialog__preview">
        {mediaType === 'video'
          ? <video src={source.url} poster={source.poster || source.previewUrl || undefined} controls preload="metadata" />
          : mediaType === 'audio'
            ? <audio src={source.url} controls preload="metadata" />
            : <img src={source.previewUrl || source.url} alt="待收藏素材" />}
      </div>
      <div className="canvas-material-dialog__fields">
        <label><span>素材名称</span><input autoFocus maxLength={100} value={name} onChange={(event) => setName(event.target.value)} placeholder="输入便于识别的名称" /></label>
        {mediaType === 'image' && <label><span>图片收藏分组</span><select value={collectionId} onChange={(event) => setCollectionId(event.target.value)}>{collections.map((item) => <option value={item.id} key={item.id}>{item.name}</option>)}</select></label>}
      </div>
      <footer>
        <button type="button" onClick={onClose} disabled={busy}>取消</button>
        <button type="submit" className="is-primary" disabled={busy || !collectionId || !name.trim()}>
          {busy ? <LoaderCircle className="spin" size={15} /> : <FolderPlus size={15} />}{busy ? '正在保存' : submitLabel}
        </button>
      </footer>
    </form>
  </div>;
}
